"use client";

import { Skeleton, SkeletonText, SkeletonArticle } from "@/components/ui/skeleton";

export default function PublicLoading() {
  return (
    <main className="flex min-h-screen p-6">
      <div className="mx-auto max-w-7xl w-full space-y-8 animate-fade-in">
        <div className="flex h-12 items-center justify-between gap-4">
          <Skeleton variant="text" className="h-7 w-36" />
          <div className="flex items-center gap-3">
            <Skeleton variant="rectangular" className="h-9 w-40" />
            <Skeleton variant="circular" />
            <Skeleton variant="circular" />
          </div>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          <SkeletonArticle />
          <SkeletonArticle />
          <SkeletonArticle />
        </div>
      </div>
    </main>
  );
}
